import { useInfiniteQuery } from '@tanstack/react-query';
import { DateRange } from 'components/DateRangeFilter/Dropdown';
import { CALLS_PAGE_SIZE } from 'constants/reporting';
import { DATE_RANGE_TIME_FORMAT } from 'constants/reporting';
import dayjs from 'dayjs';
import ReportContext from 'context/ReportContext';
import { useContext } from 'react';

type UseCallsQueryProps = {
  dateRange: DateRange | undefined;
};

const useCallsQuery = ({ dateRange }: UseCallsQueryProps) => {
  const {
    actions: { getCalls },
  } = useContext(ReportContext);

  const { data, fetchNextPage, hasNextPage, isFetchingNextPage, isLoading } =
    useInfiniteQuery({
      queryKey: ['calls', dateRange?.from, dateRange?.to],
      queryFn: async ({ pageParam = 1 }) => {
        return getCalls({
          start_date: dayjs(dateRange?.from).format(DATE_RANGE_TIME_FORMAT),
          end_date: dayjs(dateRange?.to).format(DATE_RANGE_TIME_FORMAT),
          page: pageParam,
          size: CALLS_PAGE_SIZE,
        });
      },
      getNextPageParam: (lastPage, pages) => {
        const totalFetched = pages.reduce(
          (acc, page) => acc + page.items.length,
          0
        );
        return totalFetched < lastPage.total ? pages.length + 1 : undefined;
      },
      initialPageParam: 1,
    });

  return { data, fetchNextPage, hasNextPage, isFetchingNextPage, isLoading };
};

export default useCallsQuery;
